import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { Progetto } from '../types';

interface BudgetProgressBarCompactProps {
  progetto: Progetto;
  percentualeAllocazione: number; // Percentuale di allocazione corrente (es: 30%)
}

const BudgetProgressBarCompact: React.FC<BudgetProgressBarCompactProps> = ({
  progetto,
  percentualeAllocazione
}) => {
  const budgetTotale = progetto.budget_gg_uu || 0;
  const budgetPianificato = progetto.budget_pianificato_gg_uu || 0;

  // Calcola budget disponibile
  const budgetDisponibile = budgetTotale - budgetPianificato;

  // Calcola percentuale di utilizzo
  const utilizzato = budgetPianificato;
  const percentualeUtilizzo = budgetTotale > 0
    ? Math.min((utilizzato / budgetTotale) * 100, 100)
    : 0;

  // Determina il colore in base al budget disponibile
  let coloreBarra: 'success' | 'warning' | 'error' = 'success';
  if (budgetDisponibile < 0) {
    coloreBarra = 'error'; // Rosso - sforamento
  } else if (budgetTotale > 0) {
    const percentualeDisponibile = (budgetDisponibile / budgetTotale) * 100;
    if (percentualeDisponibile <= 20) {
      coloreBarra = 'warning'; // Giallo - attenzione
    }
  }

  // Calcola giorni/uomo corrispondenti a questa percentuale (22 gg lavorativi al mese)
  const giorniUomoAllocazione = Math.round((percentualeAllocazione / 100) * 22 * 10) / 10;

  // Arrotonda i valori per la visualizzazione
  const formatGiorni = (val: number) => Math.round(val * 10) / 10;

  return (
    <Box sx={{ width: '100%', mt: 0.5, pointerEvents: 'none' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
        <Typography variant="caption" sx={{ fontSize: '0.65rem' }} color="text.secondary">
          Budget: {formatGiorni(utilizzato)}gg / {formatGiorni(budgetTotale)}gg
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.65rem',
            fontWeight: 'bold',
            color: budgetDisponibile < 0 ? 'error.main' : 'text.secondary'
          }}
        >
          Disp: {formatGiorni(budgetDisponibile)}gg
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={percentualeUtilizzo}
        color={coloreBarra}
        sx={{
          height: 6,
          borderRadius: 1,
          backgroundColor: 'action.hover'
        }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.3 }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.65rem',
            fontStyle: 'italic',
            color: 'primary.main'
          }}
        >
          Questa alloc: {giorniUomoAllocazione}gg
        </Typography>
      </Box>
    </Box>
  );
};

export default BudgetProgressBarCompact;
